import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title } from "components/misc";
import { dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Container, Col, Row } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { revisionService } from "libs/api/revisionService";
import { LESSON_ACTIVITY_TYPES, REVISOR_CONTEXTS, ROUTES } from "const";
import { getCurrentRevisor } from "store/actions";

class ReviewHistorySecurity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      rndKey: 0,
      payload: [],
      revisorIdSecurity: null,
      activityType: LESSON_ACTIVITY_TYPES.TFA_CLASSICO,
    };
  }

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },

      {
        id: "revisionDate",
        Header: "Data revisione",
        accessor: "revisionDate",
        Cell: ({ value }) => (value ? dateHelper.toITDate(value) : "-"),
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.location.href = ROUTES.CURRENT_REVISION_SECURITY_DETAIL + "/" + value;
        },
      },
    ],
  };

  //--- ---

  componentDidMount() {
    const revisor = getCurrentRevisor(REVISOR_CONTEXTS.TIROCINIODIRETTO);
    const revisorIdSecurity = revisor?.id;

    if (revisorIdSecurity) {
      this.setState({ revisorIdSecurity });
      this.loadRemote(revisorIdSecurity);
    } else this.loadRemote();
  }

  loadRemote(revisorIdSecurity) {
    this.setState({ loading: true });

    const { status } = this.props.match.params;
    const { activityType } = this.state;

    const filter = {
      status,
      revisorIdSecurity,
      lessonType: "training",
      code: "attestatoSicurezza",
      activityType,
    };

    revisionService
      .listAllSecurityCertificates(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];

        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
            loadingError: true,
          });
        }
      });
  }

  //--- ---

  render() {
    const { loading, payload } = this.state;

    return (
      <>
        <Row>
          <Col>
            <Title>Storico Revisioni - Attestati sulla sicurezza</Title>
          </Col>
        </Row>
        <hr />
        <section className="my-4">
          <Container>
            {loading ? (
              <MnemoLoading />
            ) : (
              <>
                <MTable key={this.state.rndKey} tableData={payload} tableConfig={this.tableConfig} />

                {payload.length === 0 && (
                  <BoxDanger key="nrp-1" className="my-3">
                    <div className="small text-info">Non ci sono dati da mostrare in database.</div>
                  </BoxDanger>
                )}
              </>
            )}
          </Container>
        </section>
      </>
    );
  }
}

export default withRouter(ReviewHistorySecurity);
